// Mon, 30/09/2024, 11:52 is replaced by the version number during the build process
export const version = "Mon, 30/09/2024, 11:52";
